/** @format */

// busRequest.js
import { emitter } from './eventBus';

export function busRequest1(action, payload) {
  return new Promise((resolve) => {
    const id = Math.random().toString(36).slice(2);

    const responseEvent = `response:${id}`;

    const handler = (data) => {
      emitter.off(responseEvent, handler);
      resolve(data);
    };

    emitter.on(responseEvent, handler);

    emitter.emit(action, { id, payload });
  });
}
export function busRequest(action, payload, timeout = 5000) {
  return new Promise((resolve, reject) => {
    const id = Math.random().toString(36).slice(2);
    const responseEvent = `response:${id}`;

    const timer = setTimeout(() => {
      emitter.off(responseEvent, handler);
      reject(new Error('Timeout'));
    }, timeout);

    const handler = (data) => {
      clearTimeout(timer);
      emitter.off(responseEvent, handler);
      resolve(data);
    };

    emitter.on(responseEvent, handler);
    emitter.emit(action, { id, payload });
  });
}
